import { Report } from '@shared/enums/report.enum';

import { generatedEnvironment } from './environment.generated';
import { FeatureFlag, IEnvironment } from './environment.interface';

export const environment: IEnvironment = {
  environment: 'prod',
  production: true,
  hotjarId: 2966070,
  heapAppId: '2677470127',
  useServiceWorkers: true,
  serviceWorkersCheckUpdatesMins: 60,
  enableServiceWorkerVerboseLogging: true,
  appInsightsConnectionString:
    'InstrumentationKey=9cb07c81-f963-48be-a35d-eba4d7a766ec;IngestionEndpoint=https://australiasoutheast-0.in.applicationinsights.azure.com/;LiveEndpoint=https://australiasoutheast.livediagnostics.monitor.azure.com/',
  sparkPlusApplicationId: '013f2073-1dab-4316-86fc-12b8e5d6a306',
  sparkPlusB2CTenant: 'libfinintroducers',
  sparkPlusB2CUserFlow: 'B2C_1A_SparkPlusUI_Signin_MFA',
  iqApplicationId: 'af2924c2-eacc-4cc8-a7ed-2473b91aff81',
  iqB2CTenant: '7a302886-44dd-45cf-9440-3cd0753fd920',
  iqB2CUserFlow: 'B2C_1A_IQ_SIGNIN',
  iqRedirectUri: 'https://iq.liberty.com.au/',
  clientsApiUrl: 'https://spcli.liberty.com.au/',
  clientsApiScopes: [
    'https://libfinintroducers.onmicrosoft.com/spark/opportunity-api/user_impersonation'
  ],
  managementApiUrl: 'https://spmng.liberty.com.au/',
  managementApiScopes: [
    'https://libfinintroducers.onmicrosoft.com/spark/management-auth-api/user_impersonation'
  ],
  opportunityApiUrl: 'https://spopp.liberty.com.au/',
  opportunityApiScopes: [
    'https://libfinintroducers.onmicrosoft.com/spark/opportunity-api/user_impersonation'
  ],
  libraryApiUrl: 'https://services.liberty.com.au/api/aggregationplatform-library/',
  libraryApiScopes: [
    'https://libfinintroducers.onmicrosoft.com/spark/library-api/user_impersonation'
  ],
  glassGuideApi: {
    url: 'https://motglass-search-dang21.search.windows.net/',
    key: 'YLXcZl8P8GWpUJ72A5xMJuVJICLkBQfqN8st0sngqyAzSeBNczz9'
  },
  googleMapsApi: {
    key: 'AIzaSyCSxKnCz64yHALIPBds-NYE3PLxnY4T6_U'
  },
  iqAuthApiUrl: 'https://api-iq.liberty.com.au/auth/',
  iqAuthApiScopes: [
    'https://libfinintroducers.onmicrosoft.com/iq/auth-api/user_impersonation'
  ],
  libertyGatewayUrl: 'https://api-iq.liberty.com.au/',
  opportunityDocumentApiUrl:
    'https://services.liberty.com.au/api/spark-document-storage/',
  opportunityDocumentApiScopes: [
    'https://libfinintroducers.onmicrosoft.com/spark/opportunity-api/user_impersonation'
  ],
  iqWebUrl: 'https://iq.liberty.com.au',
  features: {
    [FeatureFlag.OpportunitySubmission]: true,
    [FeatureFlag.OpportunityESignPAPP]: true,
    [FeatureFlag.OpportunityMoneyplaceBorrowCapacity]: true,
    [FeatureFlag.ProductMatrix]: true,
    [FeatureFlag.Kyc]: true,
    [FeatureFlag.ContactDeletion]: true,
    [FeatureFlag.ContactReassignment]: true,
    [FeatureFlag.Reports]: true,
    [FeatureFlag.Insurance]: true,
    [FeatureFlag.Refix]: true,
    [FeatureFlag.CommercialMotor]: true,
    [FeatureFlag.AliGroupInsurance]: true,
    [FeatureFlag.LnsPanelLenders]: true,
    [FeatureFlag.BridgingFinance]: true,
    [FeatureFlag.CapitaliseInterest]: true,
    [FeatureFlag.OpportunityPlanner]: true,
    [FeatureFlag.Reverse]: true,
    [FeatureFlag.ServicingOverride]: true,
    [FeatureFlag.FactFind]: true,
    [FeatureFlag.FactFindTemplates]: false,
  },
  settings: {
    [FeatureFlag.Reports]: {
      [Report.Lending]: {}
    }
  },
  retryConfig: {
    maxRetries: 5,
    delayMs: 2000
  },
  ...generatedEnvironment
};
